<template>
  <div>
    <div class="row justify-content-between mb-3">
      <div class="col-auto">
        <button @click="$router.push({ name: 'costs-index' })" class="btn btn-secondary">
          <i class="bi bi-arrow-left"></i> Retour
        </button>
      </div>
      <div class="col-auto">
        <button @click="editCost" class="btn btn-primary">
          <i class="bi bi-pencil-square"></i> Modifier
        </button>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5 class="mb-0">Détails du coût</h5>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-3">
            <strong>Référence:</strong> {{ cost.reference }}
          </div>
          <div class="col-md-6">
            <strong>Nom complet:</strong> {{ cost.fullName }}
          </div>
          <div class="col-md-3">
            <strong>TVA %:</strong> {{ cost.tva || "—" }}
          </div>
        </div>

        <div class="row mb-3" v-if="cost.remark">
          <div class="col-md-12">
            <strong>Remarque:</strong> {{ cost.remark }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("cost", {
      cost: "getCost",
    }),
  },
  mounted() {
    this.$store.dispatch("cost/show", this.$route.params.reference);
  },
  methods: {
    editCost() {
      this.$router.push({
        name: "costs-edit",
        params: { reference: this.cost.reference },
      });
    },
  },
};
</script>

